export default __webpack_public_path__ + "static/grid-1-7cce19054ca8cb0a74937f3066cccd44.svg";